module.exports = __webpack_public_path__ + "email-editor-grab-597f3dd6b272c6c86c14b87fab7976a9.png";